import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import "./LocationChart.css";
import { chartColors } from "../../config/constantsColor";
import { images } from "../../config/images";

const LocationChart = ({
  data,
  locationStatusChoice,
  locationDataStatusChoice = locationStatusChoice,
  setLocationStatusChoice,
}) => {
  const transformData = (rawData) => {
    if (!rawData || !Array.isArray(rawData)) return { data: [] };

    return {
      data: rawData.map((location) => ({
        name: location.location,
        y: location.total_count,
        details: Object.entries(location.sizes)
          .filter(([size]) => size !== "3" && size !== "4" && size !== "12") // Exclude unwanted sizes
          .map(([size, value]) => ({
            size: size.replace("-", " ") + '"',
            value: value,
          })),
      })),
    };
  };

  const options = {
    chart: {
      type: "column",
      height: 400,
      zoomType: "x",
    },
    title: {
      text: null,
    },
    scrollbar: {
      enabled: true,
    },
    xAxis: {
      type: "category",
      title: {
        text: null,
        style: {
          fontSize: "18px",
          color: "#001323",
        },
        y: 20,
      },
      labels: {
        useHTML: true,
        style: {
          fontSize: "16px",
          textAlign: "center",
          color: "#222D39",
        },
      },
      lineWidth: 0,
      lineColor: "transparent",
    },
    legend: {
      enabled: false,
    },
    credit: {
      enabled: false,
    },
    yAxis: {
      title: {
        text: locationDataStatusChoice,
        style: {
          fontSize: "18px",
          color: "#001323",
        },
        x: -10,
      },
      lineWidth: 0,
      lineColor: "transparent",
      minorGridLineWidth: 0,
      gridLineWidth: 0,
    },
    legend: {
      enabled: false,
    },
    plotOptions: {
      column: {
        color: chartColors[locationDataStatusChoice],
        borderRadius: 4,
      },
    },
    series: [
      {
        name: locationDataStatusChoice,
        data: transformData(data)?.data || [],
      },
    ],
    credits: {
      enabled: false,
    },
    tooltip: {
      useHTML: true,
      formatter: function () {
        const details = this.point.details;
        let tooltipContent = `<div style="padding: 8px;">`;
        details.forEach((detail) => {
          tooltipContent += `${detail.size}: ${detail.value}<br/>`;
        });
        tooltipContent += "</div>";
        return tooltipContent;
      },
    },
  };

  return (
    <Box className="location-chart-container">
      <div className="location-chart-header">
        <div className="chart-title">Locations</div>
        <select
          className="chart-select"
          value={locationStatusChoice}
          onChange={(e) => setLocationStatusChoice(e.target.value)}
        >
          <option value="Counterfeit">Counterfeit</option>
          <option value="Cross Selling">Cross Selling</option>
        </select>
      </div>
      {data.length > 0 ? (
        <>
          <HighchartsReact highcharts={Highcharts} options={options} />
          <div className="x-axis-label">Locations</div>
        </>
      ) : (
        <div className="no-data-container">
          <img
            src={images.noDataFoundImg}
            className="no-data-img"
            alt="No Data Found"
          />
        </div>
      )}
    </Box>
  );
};

export default LocationChart;
